import { gql } from '@apollo/client'

export const PRODUCT_DASHBOARD_STAT_FRAGMENT = gql`
  fragment ProductDashboardStat on ProductDashboardStat {
    id
    name
    category
    description
    totalRevenue
    previousTotalRevenue
    totalEarnings
    volume
    vpo
    previousVolume
    facings
    emptyFacings
    sovi
    revenuePerFacing
    earningsPerFacing
  }
`
